import React from 'react';
import { useContext } from "react";
import 'bulma/css/bulma.min.css';

import { AppConfigurationContext } from './../appConfigurationProvider.tsx';
import { QrCodeImage } from '../components/qrcode/qrCodeImage.tsx';
import { QrEncoding, QrErrorCorrectionLevel } from '../components/qrcode/qrCodeTypes.ts';
import './setLabel.css';


// Settings passed in with the React component
interface SetLabelProps {
  beamlineName: string;
  esafName: string;
  setName: string;
  setSlug: string;
  marginAfterHorizontal: string;
  marginAfterVertical: string;
}


const SetLabel: React.FC<SetLabelProps> = (props) => {

    const appConfig = useContext(AppConfigurationContext);

    // Note: The value in BASE_URL cannot contain underscores, or anything else outside
    // the QR alphanumeric format.  That format allows only the following:
    // Digits 0 to 9, letters A to Z (capitals only), and " ", "$", "%", "*", "+", "-", ".", "/", ":"
    const qrContent = `${appConfig.config.baseUrl}/set/${props.setSlug}`;

    return (
      <div className="setLabel" style={{ margin: `0 ${props.marginAfterHorizontal}mm ${props.marginAfterVertical}mm 0` }}>
        <div className="qrCode">
          <QrCodeImage size="10mm"
            mode={QrEncoding.Byte}
            errorCorrectionLevel={QrErrorCorrectionLevel.L}
            content={qrContent} />
        </div>
        <div className="textArea">
          <div>{ props.beamlineName }</div>
          <div>{ props.esafName }</div>
          <div>{ props.setName }</div>
        </div>
      </div>
    )
}

export default SetLabel
